import Components from "./components";
import Services from "./service";
import {WatchListStore} from "./store/WatchListStore";

export default angular.module("tfApp.watchlist", [Components(), Services()])
                      .service(WatchListStore.id, WatchListStore)
                      .name;
